import React, { useEffect, useState } from 'react'
import { enumUtil } from '../../../../../../utils/Enum';
import { useSelector } from 'react-redux';
import { ServerRequestProtected } from '../../../../../../utils/ServerDataRequest';
// import { TabActionEncounters } from '../../../../../../actions/BillingActions';
import { useDispatch } from 'react-redux';
import isNull from '../../../../../../utils/NullChecking';
import { FindFirstChild } from '../../../../../../utils/FindMenuOption';

const PastEncounters = (props) => {
    let { patientID } = props;
    let isViewAllowed = FindFirstChild('Patient', 'Encounter')?.ISView ?? true
    // let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd ?? true;
    // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    const API_URL = enumUtil.controller.General;
    let dispatch = useDispatch();

    const [encountersData, setEncountersData] = useState([]);

    const LoadData = () => {
        // setIsLoading(true);
        setEncountersData([])
        ServerRequestProtected(API_URL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": patientID,
            "SearchCriteria": {
                "Param": "Clinical"
            }
        })
            .then((response) => {
                // setIsLoading(false);
                setEncountersData(response.Rows);
                // setIs(true);
            }).catch((error) => {
                // setIsLoading(false)
            })
    }

    useEffect(() => {
        console.log("prop reload PAST ENCOUNTERS")
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 218) {
                    LoadData()
                }
            })
            if (data.length === 0) {
                LoadData()
            }
        }
    }, [props.Reload])

    const handleOpenEncounter = (encounter) => {
        if (!isViewAllowed) return;
        let obj = {
            active: true,
            key: 2,
            name: "Encounter",
            data: {
                name: `${encounter.EncounterDate}`,
                id: encounter.EncounterID,
                type: encounter.NoteType,
                // patID: PatientIDR,
                time: new Date()
            },
        }
        // dispatch(TabActionEncounters(obj));      
        dispatch({
            type: 'Open_Encounter_Tab',
            payload: {
                patientId: patientID,     // <-- needed to find the patient tab to update
                tab: obj            // the encounter tab object
            }
        });
    }

    return (
        <>

            <div className="C_Head p-1 ">
                <p className="heading">PAST ENCOUNTERS</p>
            </div>
            <div className="ar_encounter_main_screen ">
                <div className=" encounter_summary">
                    <div className="encounter_summary-content hover-scrollbar">
                        <div className="encounters-tabs d-flex flex-column gap-2">
                            <div className='content-box d-flex flex-column row-gap-13'>
                                {encountersData.length > 0 &&
                                    encountersData.map((encounter, index) =>
                                    (<div className={`d-flex flex-column gap-01 pb-1 ${index === encountersData.length - 1 ? '' : 'br-bottom-1 br-clr-light-light'}`} key={index}>
                                        <p className="fs-13 text font-m ">
                                            <div className="d-flex align-items-center gap-01">
                                                <p className={`cursor-pointer ar-hover-text ${isViewAllowed ? '' : 'disable'}`} onClick={() => handleOpenEncounter(encounter)}>{encounter.EncounterDate}</p>
                                                <span className="text fs-13">-</span>
                                                <span className="text  fs-13"> {encounter.EncounterType}</span>
                                            </div>
                                        </p>
                                        <p className="text">{encounter.NoteType}</p>
                                        <p className="text multiline-ellipsis" title={encounter.ChiefComplaint}>CC: {encounter.ChiefComplaint}</p>
                                        {encounter?.EncounterStatus === 'Signed' ?
                                            <p className='Paid heading font-m ar-status-clm w-max-content'>Signed</p> :
                                            encounter?.EncounterStatus === 'In Progress' ?
                                                <p className='Blue-Status heading font-m ar-status-clm w-max-content'>In Progress</p> :
                                                encounter?.EncounterStatus === 'Ready for Review' ?
                                                    <p className='In-Review heading font-m ar-status-clm w-max-content'>Ready for Review</p> :
                                                    ['Unsigned', 'UnSigned'].includes(encounter?.EncounterStatus) &&
                                                    <p className='Not-Signed heading font-m ar-status-clm w-max-content'>Unsigned</p>}
                                    </div>))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PastEncounters